// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"9e95e83a","297":"e848971c","306":"8c6049c8","598":"7d6d212e","629":"e90fc5f2","813":"c3926183","939":"dc2e2116"}[chunkId] + ".chunk.js";
};